import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
// ---- external imports ----

import { turnSelectors, financialStatementsSelectors } from '~/store';
import { automateFinancialStatementsViaBookkeepers } from '~/store/financial-statements/actions';
import { EMPLOYEES_HIRE } from '~/store/employees/actionTypes';
// ---- internal imports -----

const CALIBRE_TO_AUTOMATE_FINANCIAL_STATEMENTS = 2;
const CALIBRE_TO_AUTOMATE_FINANCIAL_RATIOS = 3;

const onHireBookkeeperEpic = (action$, state$) => action$.pipe(
	ofType(EMPLOYEES_HIRE),
	map((action) => {
		const hiredEmployee = action.employee;
		const isHiredEmployeeBookkeeper = hiredEmployee.jobTitle === 'Bookkeeper';
		const canBookkeeperAutomateFinancialStatements = 
            hiredEmployee.calibre >= CALIBRE_TO_AUTOMATE_FINANCIAL_STATEMENTS;

		const quarterNum = turnSelectors.getCurrentQuarterNum(state$.value) - 1;
		const isFinancialStatementsSubmittedForQuarter = financialStatementsSelectors
			.isFinancialStatementsSubmittedForQuarter(state$, quarterNum);

		const shouldSubmitFinancialStatements =
			isHiredEmployeeBookkeeper
			&& canBookkeeperAutomateFinancialStatements
			&& !isFinancialStatementsSubmittedForQuarter;

		if (shouldSubmitFinancialStatements) {
			const shallAutomateFinancialRatios =
                hiredEmployee.calibre >= CALIBRE_TO_AUTOMATE_FINANCIAL_RATIOS;
			
			//	Bookkeeper fills statements of the previous quarter
			const systemFinancialStatements = financialStatementsSelectors
				.getSystemFinancialStatementsFor(state$.value, quarterNum);

			
			return automateFinancialStatementsViaBookkeepers(
				quarterNum,
				systemFinancialStatements,
				shallAutomateFinancialRatios
			);
		}
               
	}),
	filter(Boolean)
);

export default onHireBookkeeperEpic;
